import { useEffect } from 'react';
import BannerSection from '../../components/AboutPages/Banner'
import Section2 from '../../components/PrivacyPages/Section2'
import bannerImage from '../../images/asserts/Website-Assets/Terms & Conditions/Hero_image.webp'
const Terms = () => {
     useEffect(() => {
     
        const lang = localStorage.getItem("i18nextLng");
        if (!lang || lang === "en-US") {
          localStorage.setItem("i18nextLng", "en");
          window.location.reload();
        }
    
    
     
    
    
        return () => {

        };
      }, []); 
    return (
        <main>
            <BannerSection title='Terms & Conditions' image={bannerImage} />
            <Section2 />
        </main>
    )
}

export default Terms